import { Component, OnInit } from '@angular/core';
import { ExamService } from 'src/app/services/Exam/exam.service';
import { LookupService } from 'src/app/services/Common/lookup.service';
import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';
import { GlobalHelper } from 'src/app/services/Common/global.service';

@Component({
  selector: 'app-discipline-class-map',
  templateUrl: './discipline-class-map.component.html',
  styleUrls: ['./discipline-class-map.component.css']
})
export class DisciplineClassMapComponent implements OnInit {
  constructor(private examService:ExamService,private lookupService: LookupService, private globalHelper: GlobalHelper,     private spinnerService: Ng4LoadingSpinnerService) { }
  
ExamModel = {
    ClassID: 0,
    TermID: 0,
    IsPublished: false,
};
Clear () {
    this.ExamModel.ClassID = 0;
    this.ExamModel.TermID = 0;
    this.ListExam = [];
}
ListExam = [];

 ValidateDropdown() {
    return this.ExamModel.ClassID == 0 || this.ExamModel.TermID == 0;
};
TermList = [];
ExamMasterList = [];
GetTerm () {
    this.spinnerService.show();
    this.ExamModel.TermID = 0;
    this.TermList = [];
    this.ExamMasterList = [];
    this.ListExam = [];
    var ItemBo = {
        ItemId: this.ExamModel.ClassID
    }
     this.lookupService.GetLookupsList('ExamTerm', JSON.stringify(ItemBo)).subscribe( (data)=> {
        this.TermList = data.LookupItems;
       this.spinnerService.hide();

    });
};

Submitted = false;
SearchDisciplineClassMapping (valid) {
    this.Submitted = true;
    if (valid && !this.ValidateDropdown()) {
        

        this.spinnerService.show();
       this.examService.SearchDisciplineClassMapping(JSON.stringify(this.ExamModel)).subscribe( (response)=> {
            this.ListExam = response.ListExam;
           
                this.Submitted = false;
               this.spinnerService.hide();
           
            this.globalHelper.CheckActionStatus(response);
        })
    }
};


ClassList:any;
GetAllClass () {
     this.lookupService.GetLookupsList('ClassExamFormat1', '').subscribe( (data)=> {
        this.ClassList = data.LookupItems;

    });
};


 GetDate(str) {
    var dateString = str;
    var currentTime = new Date(parseInt(dateString));
    var month = currentTime.getMonth() + 1;
    var day = currentTime.getDate();
    var year = currentTime.getFullYear();
    var date = year + "-" + (month < 10 ? "0" + month : month) + "-" + (day < 10 ? "0" + day : day);
    return date;
}


SaveDisciplineClassMapping () {
    var ExamSelectedList = [];
    var strlist = this.ListExam;
    for (var i = 0; i < strlist.length; i++) {
        if (strlist[i].IsActive == true) {
            ExamSelectedList.push(strlist[i]);
        }
    }
    
   this.examService.SaveDisciplineClassMapping(JSON.stringify(this.ExamModel), JSON.stringify(ExamSelectedList)).subscribe( (response)=> {
      
        this.globalHelper.CheckActionStatus(response);
    });
};






  ngOnInit() {
    this.GetAllClass();
  }

}
